module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/perform.js
// module id = 77
// module chunks = 0 1